/* Vehicle-scoped storefront search and buyer context. Shopify remains the search index. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.from((r || document).querySelectorAll(s)); };
  var params = new URLSearchParams(location.search);
  var requests = {};
  var inventory = null;
  var vehicle = null;
  var scope = 'all';
  var vehicleMatchers = [];
  var makeAliases = { Chevrolet: ['Chevy'], Volkswagen: ['VW'], Mercedes: ['Mercedes Benz'], 'Mini Cooper': ['Mini'] };
  var aliases = [
    [/^(alternators?|altenators?|generators?)$/i, 'Alternator Generator'],
    [/^(engines?|engine motors?|engine assemblies|engine assembly)$/i, 'Engine Motor Assembly'],
    [/^(transmissions?|transaxles?)$/i, 'Transmission Transaxle Assembly'],
    [/^(starters?|starter motors?)$/i, 'Engine Starter Motor'],
    [/^head[\s-]*(?:lights?|lamps?)$/i, 'Headlight Headlamp Assembly'],
    [/^tail[\s-]*(?:lights?|lamps?)$/i, 'Tail Light Lamp Assembly'],
    [/^tail[\s-]*gates?$/i, 'Decklid Tailgate'],
    [/^(mirrors?|door mirrors?|side mirrors?)$/i, 'Side View Door Mirror'],
    [/^(?:(?:ac|air condition(?:ing|er)) compressors?|compressors? ac)$/i, 'AC Air Conditioning Compressor'],
    [/^(transfer cases?)$/i, 'Transfer Case Assembly'],
    [/^(shifters?|gear shifters?|transmission shifters?|transmission gear shifter(?: assembly)?)$/i, 'Transmission Gear Shifter Assembly'],
    [/^(radios?|stereos?)$/i, 'Radio Stereo Audio Head Unit']
  ];
  function read(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
  function write(key, value) { try { localStorage.setItem(key, value); } catch (e) { /* optional storage */ } }
  function tag(v) { return v ? [v.year, v.make, v.model].filter(Boolean).join(' ') : ''; }
  function quote(value) { return '"' + String(value).replace(/[\\"]/g, ' ').trim() + '"'; }
  // Case, spacing and punctuation folded away: "AIR BAG", "Air Bag" and "Air-Bag" are one part type.
  function norm(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  // The part-type filter lists one clean option per type and keeps every raw yard spelling in
  // data-values. A label (or any raw spelling) expands to all of them, so filtering by the
  // clean label still finds parts typed any of the old ways.
  function typeValues(type) {
    var key = norm(type), found = null;
    $$('select[name="type"] option[data-values]').some(function (option) {
      var values = option.dataset.values.split('|');
      if (norm(option.value) === key || values.some(function (v) { return norm(v) === key; })) { found = [option.value].concat(values); return true; }
      return false;
    });
    if (!found) {
      var catalog = (window.ABM_PART_TYPES || []).filter(function (value) { return norm(value) === key; });
      if (catalog.length) found = catalog;
    }
    var seen = {};
    return (found || [type]).filter(function (v) { var k = String(v || '').toLowerCase().trim(); if (!k || seen[k]) return false; seen[k] = true; return true; });
  }
  // The clean label for a part type, whichever raw spelling a link carried.
  function typeLabel(type) {
    var key = norm(type), label = type;
    $$('select[name="type"] option[data-values]').some(function (option) {
      if (norm(option.value) === key || option.dataset.values.split('|').some(function (v) { return norm(v) === key; })) { label = option.value; return true; }
      return false;
    });
    return label;
  }
  function typeClause(type) {
    var clauses = typeValues(type).map(function (v) { return 'product_type:' + quote(v); });
    return clauses.length > 1 ? '(' + clauses.join(' OR ') + ')' : clauses[0];
  }
  // A part's R# is its SKU and CoreYard publishes the part under the handle "<prefix>-<R#>"
  // (render.HandleFor; the prefix is the installation's SHOPIFY_HANDLE_PREFIX). Shopify's handle field
  // matches the whole handle, so it finds exactly one part. variants.sku does not: it matches by
  // prefix, so "variants.sku:5990" returns abm-59900..59909 in arbitrary order and abm-5990 itself
  // can fall off the first page (8 suggestions). A handle-prefix rename must change this constant.
  var PART_HANDLE_PREFIX = 'abm-';
  function partClause(value) { return 'handle:' + quote(PART_HANDLE_PREFIX + String(value).toLowerCase()); }
  // The stock label as one phrase. Never place this bare phrase beside another clause in an OR:
  // Shopify then stops treating the OR as a union and drops a listing that matches only the other
  // side when its indexed text is long (abm-22515 vanished from "(variants.sku:22515 OR
  // "Stock #: 22515")" although variants.sku:22515 alone finds it). Fielded operands keep the union.
  function stockPhrase(value) { return quote('Stock #: ' + value); }
  function stockClause(value) { return '(tag:' + quote('search:stock:' + String(value).toLowerCase()) + ' OR body:' + stockPhrase(value) + ')'; }
  function codeTag(value) { return 'tag:' + quote('search:code:' + String(value).toLowerCase().replace(/[^a-z0-9]/g, '')); }
  // Stock numbers have five or six digits (the shortest in the catalog is 50030), Part IDs one digit or
  // more. A shorter bare number can only be a Part ID, and it must not ask for the stock label too:
  // beside handle:"abm-601" the phrase matches documents that merely mention 601, and those buried
  // abm-601 below the first page of 8 (also for 177, 200 and 627 on 2026-10-15).
  var STOCK_MIN_DIGITS = 5;
  // Yard numbers are stored dashed ("641-00118L" as a tag, "ABM-12345" as a handle over SKU 12345) but
  // people type them without the dashes. Interchange numbers are three digits, then five more with an
  // optional letter suffix (641-00118L) or, for some makes, a dotted form (663.HY1R12). Search the
  // number as typed, with separators removed, and re-dashed the stored way.
  var PART_NUMBER = /^\d{3}[\s.\-]*(?:\d{5}[a-z]{0,2}|[a-z]{2}\d[a-z]?\d{2,4})$/i;
  // A conservative standalone manufacturer-code shape. Ordinary words, short engine
  // names and year-leading vehicle text stay in the normal scoped keyword search.
  function manufacturerCode(text) {
    return /^(?=.{5,32}$)(?=.*\d{3})[a-z0-9]+(?:[._-][a-z0-9]+)*$/i.test(text) &&
      !/^(?:19|20)\d{2}(?:$|[-_.])/.test(text) && !/^\d{1,2}(?:cyl|speed)$/i.test(text);
  }
  function numberVariants(word) {
    var variants = [word];
    var compact = String(word).replace(/[\s.\-_]/g, '');
    if (compact.length < 5 || compact.length > 14 || !/\d/.test(compact) || !/^[a-z0-9]+$/i.test(compact)) return variants;
    function add(v) { if (variants.indexOf(v) === -1) variants.push(v); }
    add(compact);
    var m = compact.match(/^(\d{3})(\d{5}[a-z]{0,2})$/i);
    if (m) add(m[1] + '-' + m[2]);
    m = compact.match(/^(\d{3})([a-z]{2}\d[a-z]?\d{2,4})$/i);
    if (m) add(m[1] + '.' + m[2]);
    return variants;
  }
  var MODEL_ONLY_STOP = ['relay', 'element', 'probe', 'pilot', 'spark', 'crown', 'charger', 'compass', 'bolt', 'express',
    'vision', 'matrix', 'premier', 'summit', 'wave', 'edge', 'shadow', 'spirit', 'horizon', 'continental', 'genesis',
    'cube', 'leaf', 'tracker', 'torrent', 'venture', 'century', 'outlook', 'pursuit', 'omega', 'golf'];
  function vehiclePattern(label) {
    // Match display punctuation without changing the exact catalog tag we send Shopify.
    // F150 / F-150 / F 150 and CR-V / CRV resolve to the same inventory vehicle.
    return (label.match(/[a-z]+|\d+/gi) || []).join('[\\s&./-]*');
  }
  function vehicleExpression(label) { return new RegExp('(^|[^a-z0-9])(' + vehiclePattern(label) + ')(?=$|[^a-z0-9])', 'i'); }
  function indexVehicles() {
    Object.keys(inventory.makes).forEach(function (make) {
      Object.keys(inventory.makes[make]).forEach(function (model) {
        vehicleMatchers.push({ make: make, model: model, modelPattern: vehicleExpression(model),
          fullPatterns: [make].concat(makeAliases[make] || []).map(function (label) { return vehicleExpression(label + ' ' + model); }) });
      });
    });
  }
  function loadVehicles(src) {
    if (!requests[src]) requests[src] = fetch(src).then(function (r) {
      if (!r.ok) throw new Error('Vehicle inventory unavailable');
      return r.json();
    }).catch(function (error) { delete requests[src]; throw error; });
    return requests[src];
  }
  function valid(v) {
    if (!v || !inventory || !Object.prototype.hasOwnProperty.call(inventory.makes, v.make)) return false;
    if (!v.model) return !v.year && (inventory.make_only || []).includes(v.make);
    var years = inventory.makes[v.make][v.model];
    return Array.isArray(years) && (!v.year || years.map(String).includes(String(v.year)));
  }
  function parseVehicle(text) {
    if (!inventory) return null;
    var years = text.match(/\b(?:19|20)\d{2}\b/g) || [];
    var year = years.length === 1 ? years[0] : '';
    var matches = [];
    function add(entry, match) {
      var remaining = text.slice(0, match.index + match[1].length) + ' ' + text.slice(match.index + match[0].length);
      if (year) remaining = remaining.replace(new RegExp('\\b' + year + '\\b'), ' ');
      matches.push({ vehicle: { make: entry.make, model: entry.model, year: year }, matched: match[2], remaining: remaining.trim() });
    }
    vehicleMatchers.forEach(function (entry) {
      entry.fullPatterns.some(function (pattern) { var match = text.match(pattern); if (match) add(entry, match); return !!match; });
    });
    // A year plus an unambiguous model ("2007 Civic") is enough. Never guess between
    // makes, or override an explicitly typed make with another make's model.
    var namesMake = Object.keys(inventory.makes).some(function (make) { return vehicleExpression(make).test(text); });
    if (!matches.length && year && !namesMake) {
      vehicleMatchers.forEach(function (entry) {
        if (!/[a-z]/i.test(entry.model)) return;
        var match = text.match(entry.modelPattern); if (match) add(entry, match);
      });
    }
    // Shoppers type "camry door" and "f150 headlight" with no make or year. A model name of four or
    // more characters, starting with a letter, is safe to take on its own when only one make uses it
    // (the identity check below refuses Kia/Isuzu "Optima"); names that are also part words
    // ("relay", "element", "leaf spring", "pilot bearing") are left to the text search.
    if (!matches.length && !year && !namesMake) {
      vehicleMatchers.forEach(function (entry) {
        var key = entry.model.toLowerCase();
        if (!/^[a-z]/.test(key) || key.replace(/[^a-z0-9]/g, '').length < 4 || MODEL_ONLY_STOP.indexOf(key) !== -1) return;
        var match = text.match(entry.modelPattern); if (match) add(entry, match);
      });
    }
    if (matches.length) {
      var longest = Math.max.apply(null, matches.map(function (m) { return m.matched.replace(/[^a-z0-9]/gi, '').length; }));
      matches = matches.filter(function (m) { return m.matched.replace(/[^a-z0-9]/gi, '').length === longest; });
      var identities = matches.map(function (m) { return tag(m.vehicle); });
      if (new Set(identities).size === 1) return matches[0];
      return null;
    }
    var make = (inventory.make_only || []).find(function (name) { return name.toLowerCase() === text.toLowerCase(); });
    return make ? { vehicle: { make: make }, matched: text, remaining: '' } : null;
  }
  function resolve(term, options) {
    options = options || {};
    var text = String(term || '').trim().replace(/\ba\s*\/\s*c\b/gi, 'ac');
    var codes = [];
    text = text.replace(/\b(?:oem|oe|interchange|hollander|casting)\s*(?:(?:part\s*)?(?:numbers?|no\.?|#))?\s*[:#]?\s*([a-z0-9][a-z0-9._-]*\d[a-z0-9._-]*|\d{3,})(?=$|[\s),;])/gi, function (_, code) {
      codes.push(code); return ' ';
    });
    text = text.replace(/\b(\d{3})\s*[-.\s]\s*(\d{5}[a-z]{0,2})\b/gi, '$1-$2').replace(/\s+/g, ' ').trim();
    // A bare number may be a donor stock number OR an individual part's R#/SKU.
    // Dedicated stock tags survive description truncation; older listings retain a body fallback.
    var stock = text.match(/\b(?:stock|stk)\s*(?:number|no\.?|#)?\s*[:#-]?\s*([a-z0-9][a-z0-9._-]{0,23})(?=$|[\s),;])/i);
    var id = (stock ? text.replace(stock[0], ' ') : text).match(/(?:^|[\s(])(?:r\s*#?|#|abm\s*[-#]?|part\s*(?:id|number|no\.?|#))\s*[:#]?\s*(\d{1,7})(?=$|[\s),;])/i);
    var bare = !stock && !id && text.match(/^\d{1,7}$/);
    // A long yard number plus a part name is also an identifier lookup. Do not
    // mistake a vehicle year or engine size for a stock number.
    var mixed = !stock && !id && !bare && !PART_NUMBER.test(text) && !manufacturerCode(text) && text.match(/(?:^|\s)(\d{5,7})(?=$|\s)/);
    var lookup = id ? { kind: 'part', value: id[1] } : stock ? { kind: 'stock', value: stock[1] } : bare || mixed ? { kind: 'number', value: bare ? bare[0] : mixed[1] } : null;
    if (lookup) {
      [stock, id, bare, mixed].forEach(function (match) { if (match) text = text.replace(match[0], ' '); });
      text = text.replace(/[(),;]/g, ' ').replace(/\s+/g, ' ').trim();
      if (stock && id) lookup.stock = stock[1];
    }
    var explicit = parseVehicle(text);
    if (explicit) text = explicit.remaining;
    text.split(/\s+/).forEach(function (word) {
      if ((window.ABM_STOCK_CODES || []).indexOf(word.toLowerCase()) !== -1 || PART_NUMBER.test(word) || (manufacturerCode(word) && (!/^\d+$/.test(word) || word.length > 7))) {
        codes.push(word); text = text.replace(word, ' ');
      }
    });
    text = text.replace(/\s+/g, ' ').trim();
    var selected = options.vehicle !== undefined ? options.vehicle : (scope === 'vehicle' ? vehicle : null);
    if (lookup && options.vehicle === undefined) selected = null;
    if (explicit) selected = explicit.vehicle;
    text = text.replace(/^(?:i need|looking for)\s+/i, '').replace(/\b(?:for|my|please|parts)\b/gi, ' ').replace(/\s+/g, ' ').trim();
    // A named make is an explicit change of vehicle even when its model is ambiguous
    // or absent from our index. Never silently combine "Ford" with a saved Honda.
    if (!explicit && inventory) {
      Object.keys(inventory.makes).forEach(function (make) {
        [make].concat(makeAliases[make] || []).some(function (name) {
          var pattern = vehicleExpression(name);
          if (!pattern.test(text)) return false;
          if (options.vehicle === undefined) selected = null;
          if (name !== make) text = text.replace(pattern, function (_, boundary) { return boundary + make; });
          return true;
        });
      });
    }
    // An interchange/manufacturer code identifies the part independently of
    // a saved vehicle. A deliberate vehicle refinement still takes precedence.
    var identifier = codes.length > 0;
    if (identifier && !explicit && options.vehicle === undefined) selected = null;
    var inferredType = '', typeRest = '';
    inferredType = (window.ABM_PART_TYPES || []).find(function (value) { return value && norm(value) === norm(text); }) || '';
    $$('select[name="type"] option[data-values]').some(function (option) {
      if (!option.value || ![option.value].concat(option.dataset.values.split('|')).some(function (value) { return norm(value) === norm(text); })) return false;
      inferredType = option.value;
      return true;
    });
    if (!inferredType) aliases.some(function (entry) { if (entry[0].test(text)) { inferredType = entry[1]; return true; } return false; });
    // "silverado mirror", "left headlight": the part word ends the phrase and the words before it
    // narrow it. Only the last words count, so "mirror glass" or "transmission mount" stay text,
    // and "motor" never does ("wiper motor" is not an engine).
    if (!inferredType) aliases.some(function (entry) {
      if (entry[1] === 'Engine Motor Assembly' && !/\bengines?$/i.test(text)) return false;
      var words = text.split(' ');
      for (var n = Math.min(3, words.length - 1); n >= 1; n--) {
        if (entry[0].test(words.slice(-n).join(' '))) { inferredType = entry[1]; typeRest = words.slice(0, -n).join(' '); return true; }
      }
      return false;
    });
    var type = options.type || inferredType;
    var remaining = type && (inferredType === type || text.toLowerCase() === type.toLowerCase()) ? typeRest : text;
    var clauses = [];
    if (lookup) {
      // A Part ID is looked up by exact handle. A bare number of five digits or more may be a Part ID
      // or a stock number, so it asks for both, with the stock side fielded (body:) to keep the OR a
      // union. A typed stock label beside a Part ID is not added to the query: Shopify indexes only the
      // start of a long description, so the label can be missing from the index of a part that really
      // carries it. identifierMatches() checks it against the listing's own stock number instead.
      var maybeStock = lookup.kind === 'number' && lookup.value.length >= STOCK_MIN_DIGITS;
      clauses.push(lookup.kind === 'stock' ? stockClause(lookup.value) : maybeStock ? '(' + partClause(lookup.value) + ' OR ' + stockClause(lookup.value) + ' OR ' + codeTag(lookup.value) + ')' : partClause(lookup.value));
    }
    if (selected) clauses.push('tag:' + quote(tag(selected)));
    if (type) clauses.push(typeClause(type));
    codes.forEach(function (code) {
      var fields = [codeTag(code), 'tag:' + quote('search:stock:' + String(code).toLowerCase())];
      numberVariants(code).forEach(function (v) {
        fields.push('body:' + quote(v), 'title:' + quote(v), 'tag:' + quote(v), 'variants.sku:' + quote(v));
      });
      clauses.push('(' + fields.join(' OR ') + ')');
    });
    // Require every remaining keyword across titles, tags, SKU and description notes.
    if (remaining) {
      // "641 00118L" and "641 - 00118L" are one interchange number, not two words.
      remaining = remaining.replace(/\b(\d{3})\s*[-.\s]\s*(\d{5}[a-z]{0,2})\b/gi, '$1-$2');
      remaining.split(/\s+/).filter(function (word) { return word && !/^(for|parts?)$/i.test(word); }).forEach(function (word) {
        var fields = [];
        numberVariants(word).forEach(function (v) {
          fields.push('title:' + quote(v), 'tag:' + quote(v), 'variants.sku:' + quote(v), 'body:' + quote(v));
        });
        clauses.push('(' + fields.join(' OR ') + ')');
      });
    }
    var shipQuery = (window.ABM_SHIP || {}).searchGroups || {};
    if (options.delivery && shipQuery[options.delivery]) clauses.push(shipQuery[options.delivery]);
    if (options.side) clauses.push('tag:' + quote(options.side));
    return { query: clauses.join(' AND ') || '*', term: lookup || identifier ? String(term || '').trim() : text, vehicle: selected, type: type, rest: remaining, lookup: lookup };
  }
  function searchURL(term, options) {
    options = options || {};
    var resolved = resolve(term, options);
    var query = new URLSearchParams({ type: 'product', q: resolved.query, 'options[unavailable_products]': 'last', 'options[prefix]': 'last', abm: '1', abm_q: resolved.term, abm_vehicle: tag(resolved.vehicle), abm_type: resolved.type });
    if (resolved.lookup) {
      query.set('options[prefix]', 'none');
      query.set('abm_id', resolved.lookup.value);
      query.set('abm_id_kind', resolved.lookup.kind);
      if (resolved.lookup.stock) query.set('abm_id_stock', resolved.lookup.stock);
    }
    ['delivery', 'side'].forEach(function (key) { if (options[key]) query.set('abm_' + key, options[key]); });
    if (options.min !== '' && options.min != null && Number.isFinite(Number(options.min))) query.set('filter.v.price.gte', options.min);
    if (options.max !== '' && options.max != null && Number.isFinite(Number(options.max))) query.set('filter.v.price.lte', options.max);
    if (options.sort) query.set('sort_by', options.sort);
    return (((window.ABM || {}).routes || {}).search || '/search') + '?' + query.toString();
  }
  function requestURL(options) {
    options = options || {};
    var q = new URLSearchParams({ vehicle: tag(vehicle), part: options.part || params.get('abm_q') || params.get('q') || '', part_id: options.id || '', reason: options.reason || '', listing: options.listing || '' });
    return '/pages/contact?' + q.toString() + '#ContactPageForm';
  }
  function updateResultScope() {
    if (!$('[data-search-heading]') || !params.get('q')) return;
    var url = new URL(searchURL(params.get('abm_q') || '', {
      vehicle: scope === 'vehicle' ? vehicle : null, type: params.get('abm_type') || '',
      delivery: params.get('abm_delivery') || '', side: params.get('abm_side') || '', sort: params.get('sort_by') || ''
    }), location.origin);
    // Price and native metafield filters survive; pagination resets to the first page.
    params.forEach(function (value, key) { if (key.indexOf('filter.') === 0) url.searchParams.append(key, value); });
    location.assign(url.pathname + url.search);
  }
  function refreshScope() {
    $$('[data-search-scope]').forEach(function (select) {
      select.replaceChildren(new Option('All vehicles', 'all'));
      if (vehicle) select.add(new Option(tag(vehicle), 'vehicle'));
      select.value = vehicle ? scope : 'all';
      select.closest('[data-search-scope-wrap]').hidden = !vehicle;
    });
    $$('[data-scope-inventory]').forEach(function (link) { link.href = (((window.ABM || {}).routes || {}).allParts || '/collections/just-pulled') + (vehicle ? '/' + tag(vehicle).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') : ''); });
    applyFitment(document);
    $$('[data-predictive-results]').forEach(function (el) { el.hidden = true; });
    $$('[data-predictive-input]').forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
    document.dispatchEvent(new CustomEvent('abm:scope', { detail: tag(vehicle) }));
  }
  // The vehicle index follows actual filter tags, while fitment keeps the catalog make.
  // Compare the same aliases used by the index builder without rewriting search tags.
  function fitmentMake(value) {
    var make = norm(value);
    var aliases = { mercedes: 'mercedes benz', chevy: 'chevrolet', vw: 'volkswagen' };
    return aliases[make] || make;
  }
  function completeApplication(row) {
    return row && String(row.make || '').trim() && String(row.model || '').trim() && String(row.years || '').trim();
  }
  function matchingRows(rows, v) {
    if (!Array.isArray(rows) || !v || !v.model) return [];
    return rows.filter(function (row) {
      if (!completeApplication(row)) return false;
      if (fitmentMake(row.make) !== fitmentMake(v.make) || String(row.model).toLowerCase() !== v.model.toLowerCase()) return false;
      if (!v.year) return true;
      var ranges = String(row.years).split(/[,;]/);
      return ranges.some(function (range) {
        var years = range.match(/\d{4}/g) || [];
        return years.length === 1 ? Number(v.year) === Number(years[0]) : years.length === 2 && Number(v.year) >= Number(years[0]) && Number(v.year) <= Number(years[1]);
      });
    });
  }
  function applyFitment(root) {
    $$('[data-fitment]', root).forEach(function (el) {
      var rows;
      try { rows = JSON.parse(el.dataset.fitment) || []; } catch (e) { return; }
      var selected = matchingRows(rows, vehicle);
      var summary = $('[data-fitment-summary]', el);
      if (summary && !summary.dataset.original) summary.dataset.original = summary.innerHTML;
      if (summary && selected.length) {
        summary.textContent = 'Application: ' + tag(vehicle) + ' · verify options';
        summary.classList.add('fitment-summary--selected');
      } else if (summary && summary.dataset.original) {
        summary.innerHTML = summary.dataset.original;
        summary.classList.remove('fitment-summary--selected');
      }
      var context = $('[data-fitment-context]', el);
      if (context && vehicle) {
        context.hidden = false;
        var heading = document.createElement('strong');
        heading.textContent = selected.length ? 'Listed application for your ' + tag(vehicle) + ' — check options' : 'Fitment not confirmed for your ' + tag(vehicle);
        var notes = document.createElement('p');
        notes.textContent = selected.length ? selected.map(function (r) { return r.note || 'Compare your options and part numbers before ordering.'; }).join(' • ') : 'Check the applications below or ask the yard with your VIN before ordering.';
        if (selected.length && notes.textContent.length > 180) {
          var details = document.createElement('details');
          var toggle = document.createElement('summary'); toggle.textContent = 'Check engine, year and option requirements';
          details.append(toggle, notes); context.replaceChildren(heading, details);
        } else context.replaceChildren(heading, notes);
      } else if (context) {
        context.hidden = true;
      }
      if (el.classList.contains('card')) $$('a[href*="/products/"]', el).forEach(function (link) {
        var url = new URL(link.href);
        if (vehicle) url.searchParams.set('abm_vehicle', tag(vehicle)); else url.searchParams.delete('abm_vehicle');
        link.href = url.pathname + url.search;
      });
    });
  }
  function enhanceRequests() {
    $$('[data-part-help]').forEach(function (link) {
      link.href = requestURL({ part: link.dataset.part || '', id: link.dataset.partId || '', reason: (link.dataset.reason || '').replace(/\\n/g, '\n'), listing: link.dataset.listing || '' });
    });
    var form = $('[data-part-request]');
    if (form) {
      var fields = { vehicle: 'vehicle', part: 'part', 'Part ID': 'part_id' };
      Object.keys(fields).forEach(function (name) {
        var input = $('[name="contact[' + name + ']"]', form);
        if (input && !input.value && input.dataset.contactRestored !== 'true') input.value = params.get(fields[name]) || (name === 'vehicle' ? tag(vehicle) : '');
      });
      var body = $('[name="contact[body]"]', form);
      if (body && !body.value && body.dataset.contactRestored !== 'true') body.value = [params.get('reason'), params.get('listing')].filter(Boolean).join('\n');
    }
  }
  /* ------------------------------------------------ exact match vs closest parts */
  // Shopify's search index is generous: a part-type clause matches any type that shares a word, and a
  // keyword query matches any one of its words. Before a card counts as a match, check it against the
  // vehicle and part type the search asked for, using only what the card carries: its part type and
  // its structured fitment. Tags retrieve candidates; missing application data cannot
  // confirm a vehicle match. Keep those cards visible as other, unverified results.
  function cardFits(card, want) {
    var rows;
    try { rows = JSON.parse(card.getAttribute('data-fitment') || '[]'); } catch (e) { rows = []; }
    return matchesSearch({ sku: card.getAttribute('data-part-id'), stock: card.getAttribute('data-stock-number'), codes: card.getAttribute('data-search-codes'), type: card.getAttribute('data-part-type'), side: card.getAttribute('data-part-side'), fitment: rows }, want);
  }
  function matchesSearch(part, want) {
    if (want.lookup && !identifierMatches(part, want.lookup)) return false;
    if (want.side && part.side !== want.side) return false;
    if (want.type) {
      var type = part.type;
      if (!type || !typeValues(want.type).some(function (value) { return norm(value) === norm(type); })) return false;
    }
    var v = want.vehicle;
    if (v && v.make) {
      var rows = part.fitment;
      if (Array.isArray(rows) && rows.length) {
        if (!v.model) return rows.some(function (r) { return completeApplication(r) && fitmentMake(r.make) === fitmentMake(v.make); });
        return matchingRows(rows, v).length > 0;
      }
      return false;
    }
    return true;
  }
  function searchWant() {
    var parsed = parseVehicle(params.get('abm_vehicle') || '');
    return { vehicle: parsed ? parsed.vehicle : null, type: params.get('abm_type') || '', side: params.get('abm_side') || '', words: params.get('abm_q') || '', lookup: params.get('abm_id') ? { kind: params.get('abm_id_kind'), value: params.get('abm_id'), stock: params.get('abm_id_stock') } : null };
  }
  function identifierMatches(part, lookup) {
    if (!lookup) return true;
    var value = String(lookup.value).trim().toLowerCase();
    var sku = String(part.sku || '').trim().toLowerCase();
    var stock = String(part.stock || '').trim().toLowerCase();
    if (lookup.stock && stock !== String(lookup.stock).trim().toLowerCase()) return false;
    var codes = String(part.codes || '').toLowerCase().match(/[a-z0-9]+(?:[._-][a-z0-9]+)*/g) || [];
    return lookup.kind === 'part' ? sku === value : lookup.kind === 'stock' ? stock === value : sku === value || stock === value || codes.indexOf(value) !== -1;
  }
  // The part whose Part ID is the number the shopper typed leads the list; stock-mates and other
  // matches follow in Shopify's order. Pure and stable, so it is safe on any page of results.
  function exactFirst(items, toPart, lookup) {
    if (!lookup || lookup.kind === 'stock') return items.slice();
    var value = String(lookup.value).trim().toLowerCase(), head = [], tail = [];
    items.forEach(function (item) { (String(toPart(item).sku || '').trim().toLowerCase() === value ? head : tail).push(item); });
    return head.concat(tail);
  }
  // Wider searches the shopper can choose, each saying exactly what it relaxes.
  function widenOptions(want) {
    var out = [], v = want.vehicle, what = want.type || want.words;
    function add(label, href) { out.push({ label: label, href: href }); }
    if (v && v.year && v.model) add((what || 'Parts') + ' for any year of ' + v.make + ' ' + v.model, searchURL(want.words, { vehicle: { make: v.make, model: v.model }, type: want.type }));
    if (v && what) add(what + ' for any vehicle', searchURL(want.words, { vehicle: null, type: want.type }));
    if (v && what) add('All parts for ' + tag(v), searchURL('', { vehicle: v }));
    if (!v && want.type && want.words) add('Any ' + want.type, searchURL('', { vehicle: null, type: want.type }));
    return out;
  }
  function renderWiden(host, want) {
    var options = widenOptions(want);
    if (!host || !options.length) return;
    var title = document.createElement('p'); title.className = 'small muted'; title.textContent = 'Closest options, one step wider:';
    var list = document.createElement('ul');
    options.forEach(function (o) { var li = document.createElement('li'); var a = document.createElement('a'); a.className = 'link'; a.href = o.href; a.textContent = o.label; li.appendChild(a); list.appendChild(li); });
    host.replaceChildren(title, list);
    host.hidden = false;
  }
  function openRequest(focus) {
    var details = $('[data-part-request-details]');
    if (details) details.open = true;
    var block = $('[data-part-request-block]');
    if (block && focus) {
      block.scrollIntoView({ block: 'start' });
      var first = $('input:not([type="hidden"])', block);
      if (first) first.focus({ preventScroll: true });
    }
  }
  function showClosest(section, cards, want, ending) {
    var grid = $('[data-closest-grid]', section);
    grid.replaceChildren.apply(grid, cards);
    var what = typeLabel(want.type) || want.words;
    if (want.side) what = [want.side, what].filter(Boolean).join(' ');
    var described = what && want.vehicle ? what + ' for ' + tag(want.vehicle) : what || (want.vehicle ? 'the ' + tag(want.vehicle) : 'your search');
    $('[data-closest-note]', section).textContent = 'These listings do not confirm ' + described + '. Check the part type, application options and fitment before ordering' + ending;
    section.hidden = false;
  }
  function qualifyResults() {
    var grid = $('[data-search-grid]');
    if (!grid || params.get('abm') !== '1') return;
    var want = searchWant();
    var closest = $('[data-closest-results]');
    var count = $('[data-results-count]');
    var exact = $$('.card[data-product-id]', grid);
    var near = [];
    if (want.vehicle || want.type || want.side || want.lookup) {
      near = exact.filter(function (card) { return !cardFits(card, want); });
      near.forEach(function (card) { exact.splice(exact.indexOf(card), 1); });
    }
    var leaders = want.lookup ? exactFirst(exact, function (card) { return { sku: card.getAttribute('data-part-id') }; }, want.lookup) : exact;
    if (leaders.some(function (card, i) { return card !== exact[i]; })) grid.prepend.apply(grid, leaders);
    var empty = $('[data-empty-state]');
    if (!exact.length) {
      // No confirmed application on this page: offer candidates and a way to ask the yard.
      var heading = $('[data-results-heading]');
      if (heading) heading.textContent = 'Other candidate parts';
      if (empty) renderWiden($('[data-widen-links]', empty), want);
      if (near.length && closest) {
        showClosest(closest, near, want, ' or request the part below.');
        renderWiden($('[data-widen-links]', closest), want);
      }
      if (count) count.textContent = '0 matching listings on this page' + (near.length ? ' · ' + near.length + ' other candidates' : '');
      grid.hidden = !exact.length;
      openRequest(false);
    } else {
      if (near.length && closest) showClosest(closest, near, want, '.');
      if (count && (want.vehicle || want.type || want.side || want.lookup)) {
        count.textContent = exact.length + (want.vehicle ? ' listings with matching applications on this page; check options' : ' listings matching the requested part filters on this page') + (near.length ? ' · ' + near.length + ' other candidates' : '');
      }
    }
  }
  function prefillRequest() {
    var block = $('[data-part-request-block]');
    if (!block) return;
    var searchedFor = $('[data-request-searched]', block), vehicleInput = $('[data-request-vehicle]', block), partInput = $('[data-request-part]', block), notes = $('[data-request-notes]', block);
    var words = params.get('abm_q') || '';
    var type = typeLabel(params.get('abm_type') || '');
    var asked = params.get('abm') === '1' ? [params.get('abm_vehicle'), type, words].filter(Boolean).join(' / ') : (params.get('q') || '');
    if (searchedFor && asked) searchedFor.value = asked;
    if (vehicleInput && !vehicleInput.value) vehicleInput.value = params.get('abm_vehicle') || tag(vehicle);
    if (partInput && !partInput.value && params.get('abm') === '1') partInput.value = /^\d{1,7}$/.test(words) ? 'Stock number or Part ID ' + words : (words || type);
    var form = block.querySelector('form');
    if (form && notes) form.addEventListener('submit', function () {
      // The email subject is fixed by Shopify, so the message itself says what it is.
      if (!/^\s*PART REQUEST/i.test(notes.value)) notes.value = 'PART REQUEST' + (notes.value.trim() ? '\n' + notes.value.trim() : '');
    });
    var success = $('[data-part-request-success]', block);
    var error = $('[data-part-request-error]', block);
    // Every contact form on the page reports success, so only believe the one that was posted.
    if (success && location.hash && location.hash !== '#PartRequestForm') success.hidden = true;
    else if (success) { block.scrollIntoView({ block: 'start' }); success.focus({ preventScroll: true }); }
    else if (error) { block.scrollIntoView({ block: 'start' }); error.focus({ preventScroll: true }); }
    $$('[data-part-request-link]').forEach(function (link) {
      link.addEventListener('click', function (e) { e.preventDefault(); openRequest(true); });
    });
  }
  function initFilters() {
    $$('[data-shopping-filters]').forEach(function (form) {
      form.hidden = false;
      var field = function (name) { return $('[name="' + name + '"]', form); };
      field('part').value = params.get('abm_q') || (params.get('abm') ? '' : params.get('q')) || '';
      ['delivery', 'side'].forEach(function (name) { field(name).value = params.get('abm_' + name) || ''; });
      // The option is the clean label; an old link may carry a raw yard spelling of it ("AIR BAG").
      field('type').value = params.get('abm_type') || '';
      if (field('type').value !== (params.get('abm_type') || '')) {
        var asked = norm(params.get('abm_type'));
        var option = $$('option', field('type')).filter(function (o) { return o.value && (norm(o.value) === asked || (o.dataset.values || '').split('|').some(function (v) { return norm(v) === asked; })); })[0];
        field('type').value = option ? option.value : '';
      }
      field('min').value = params.get('filter.v.price.gte') || '';
      field('max').value = params.get('filter.v.price.lte') || '';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (field('min').value && field('max').value && Number(field('min').value) > Number(field('max').value)) {
          field('max').setCustomValidity('Maximum must be at least the minimum price.'); field('max').reportValidity(); return;
        }
        var url = new URL(searchURL(field('part').value, { type: field('type').value, delivery: field('delivery').value, side: field('side').value, min: field('min').value, max: field('max').value, sort: params.get('sort_by') || '' }), location.origin);
        $$('[data-native-filter]', form).forEach(function (select) { if (select.value) url.searchParams.set(select.name, select.value); });
        location.href = url.pathname + url.search;
      });
      field('max').addEventListener('input', function () { this.setCustomValidity(''); });
      field('min').addEventListener('input', function () { field('max').setCustomValidity(''); });
      $$('[data-native-filter]', form).forEach(function (select) { select.value = params.get(select.name) || ''; });
      var clear = $('[data-refine-clear]', form);
      clear.href = searchURL('', {});
    });
  }
  var source = $('[data-saved-vehicle]') || $('[data-ymm]');
  var ready = source ? loadVehicles(source.dataset.src).then(function (data) {
    inventory = data;
    indexVehicles();
    var saved; try { saved = JSON.parse(read('abm:vehicle')); } catch (e) { saved = null; }
    vehicle = valid(saved) ? saved : null;
    var explicit = parseVehicle(params.get('abm_vehicle') || '');
    if (explicit) {
      vehicle = explicit.vehicle;
      if (valid(vehicle)) write('abm:vehicle', JSON.stringify(vehicle));
    }
    var facet = $('[data-ymm-facet]');
    if (facet) {
      var tags = (facet.dataset.tags || '').split('~').sort(function (a, b) { return b.length - a.length; });
      tags.some(function (value) { var parsed = parseVehicle(value); if (parsed) { vehicle = parsed.vehicle; return true; } return false; });
    }
    scope = vehicle && (params.has('abm_vehicle') ? !!params.get('abm_vehicle') : read('abm:scope') !== 'all') ? 'vehicle' : 'all';
  }).catch(function () { /* Ordinary search remains available. */ }) : Promise.resolve();
  window.ABMShopping = { ready: ready, loadVehicles: loadVehicles, searchURL: searchURL, resolve: resolve, matchingRows: matchingRows, identifierMatches: identifierMatches, matchesSearch: matchesSearch, exactFirst: exactFirst,
    requestURL: requestURL, applyFitment: applyFitment,
    remember: function (v) { vehicle = valid(v) ? v : null; scope = vehicle ? 'vehicle' : 'all'; write('abm:scope', scope); refreshScope(); if (!v.make) updateResultScope(); },
    getVehicle: function () { return vehicle; }
  };
  ready.then(function () {
    refreshScope();
    $$('[data-search-scope]').forEach(function (select) { select.addEventListener('change', function () { scope = this.value; write('abm:scope', scope); refreshScope(); updateResultScope(); }); });
    $$('[data-scope-clear]').forEach(function (button) { button.addEventListener('click', function () { var clear = $('[data-clear-vehicle]'); if (clear) clear.click(); }); });
    if (params.get('abm') === '1') {
      $$('[data-predictive-input]').forEach(function (el) { el.value = params.get('abm_q') || ''; });
      var heading = $('[data-search-heading]');
      // "silverado mirror" searches mirrors for the word "silverado"; keep that word in the heading.
      var headingType = typeLabel(params.get('abm_type') || '');
      var headingRest = headingType ? resolve(params.get('abm_q') || '', { vehicle: null, type: params.get('abm_type') }).rest : '';
      if (heading) heading.textContent = (headingType || params.get('abm_q') || 'Parts') + (headingRest ? ' · “' + headingRest + '”' : '') + (params.get('abm_vehicle') ? ' for ' + params.get('abm_vehicle') : ' — all vehicles');
    } else if ($('[data-search-heading]') && params.get('q')) {
      // Normalize legacy links through the same search contract as the form.
      var normalized = new URL(searchURL(params.get('q'), { sort: params.get('sort_by') || '' }), location.origin);
      params.forEach(function (value, key) { if (key.indexOf('filter.') === 0) normalized.searchParams.append(key, value); });
      location.replace(normalized.pathname + normalized.search);
      return;
    }
    applyFitment(document); enhanceRequests(); initFilters(); qualifyResults(); prefillRequest();
    var directory = $('[data-department-directory]');
    if (directory) {
      var input = document.createElement('input'); input.type = 'search'; input.placeholder = 'Find a make, model or department'; input.setAttribute('aria-label', input.placeholder); input.className = 'directory-search';
      var heading = $('.section-head', directory); heading.appendChild(input);
      input.addEventListener('input', function () { $$('.cat-card, .veh-index li', directory).forEach(function (tile) { tile.hidden = !tile.textContent.toLowerCase().includes(input.value.toLowerCase()); }); });
    }
  });
  // Back/forward must restore the scope represented by the URL, not a selector value
  // cached just before navigation or another page's storage preference.
  window.addEventListener('pageshow', function (event) { if (event.persisted) location.reload(); });
  $$('[data-yard-notes]').forEach(function (link) {
    link.addEventListener('click', function () {
      var description = $('#ProductDescription');
      if (description) { description.open = true; $('summary', description).focus({ preventScroll: true }); }
    });
  });
  if (location.hash === '#ProductDescription' && $('#ProductDescription')) $('#ProductDescription').open = true;
  $$('[data-gallery]').forEach(function (gallery) {
    var trigger = $('[data-gallery-zoom]', gallery);
    var main = $('[data-gallery-main]', gallery);
    if (!trigger || !main || !window.HTMLDialogElement) return;
    var dialog = document.createElement('dialog'); dialog.className = 'photo-viewer'; dialog.setAttribute('aria-label', 'Listing photo viewer');
    dialog.innerHTML = '<div class="photo-viewer__tools"><button type="button" data-photo-prev aria-label="Previous photo">←</button><span data-photo-count role="status"></span><button type="button" data-photo-next aria-label="Next photo">→</button><button type="button" data-photo-close>Close</button></div><div class="photo-viewer__image"><img alt=""></div><p>Swipe or use the arrows to change photos. Tap the image to zoom.</p>';
    document.body.appendChild(dialog);
    var photos = $$('[data-gallery-thumb]', gallery).map(function (thumb) { return { src: thumb.dataset.full, alt: thumb.dataset.alt }; });
    if (!photos.length) photos = [{ src: main.src, alt: main.alt }];
    var index = 0;
    function show(change) {
      index = (index + change + photos.length) % photos.length;
      var image = $('img', dialog); image.src = photos[index].src; image.alt = photos[index].alt || main.alt;
      image.classList.remove('is-zoomed');
      image.setAttribute('aria-pressed', 'false');
      $('[data-photo-count]', dialog).textContent = (index + 1) + ' / ' + photos.length;
      $('[data-photo-prev]', dialog).disabled = photos.length < 2; $('[data-photo-next]', dialog).disabled = photos.length < 2;
    }
    trigger.addEventListener('click', function () { index = Math.max(0, photos.findIndex(function (photo) { return photo.src === main.getAttribute('src'); })); show(0); dialog.showModal(); });
    $('[data-photo-close]', dialog).addEventListener('click', function () { dialog.close(); });
    $('[data-photo-prev]', dialog).addEventListener('click', function () { show(-1); });
    $('[data-photo-next]', dialog).addEventListener('click', function () { show(1); });
    dialog.addEventListener('close', function () { trigger.focus(); });
    dialog.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { e.preventDefault(); show(-1); } if (e.key === 'ArrowRight') { e.preventDefault(); show(1); } });
    var image = $('img', dialog); image.tabIndex = 0; image.setAttribute('role', 'button'); image.setAttribute('aria-label', 'Toggle photo zoom');
    function zoom() { image.classList.toggle('is-zoomed'); image.setAttribute('aria-pressed', image.classList.contains('is-zoomed') ? 'true' : 'false'); }
    image.addEventListener('click', zoom); image.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); zoom(); } });
    var start = null;
    image.addEventListener('touchstart', function (e) { start = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
    image.addEventListener('touchend', function (e) { if (start != null && !image.classList.contains('is-zoomed')) { var distance = e.changedTouches[0].clientX - start; if (Math.abs(distance) > 60) show(distance > 0 ? -1 : 1); } start = null; }, { passive: true });
  });
})();
